import {orderChatDeliveries} from './chatDelivery';
export type NativeAgentTurnStatus='running'|'completed'|'failed'|'stopped';
export type NativeAgentHistoryEntry=Record<string,unknown>&{id?:string;role?:unknown;content?:unknown};
export interface NativeAgentTurnMetadata {version:1;runId:string;userMessageId:string;assistantMessageId:string;status:NativeAgentTurnStatus}
export function nativeAgentTurnMetadata(entry:NativeAgentHistoryEntry):NativeAgentTurnMetadata|undefined{
 if(!entry||typeof entry!=='object')return;
 const value=entry.serverNativeAgent as Partial<NativeAgentTurnMetadata>|undefined;
 if(value?.version!==1||typeof value.runId!=='string'||typeof value.userMessageId!=='string'||typeof value.assistantMessageId!=='string'||!['running','completed','failed','stopped'].includes(value.status??'')||!((entry.role==='user'&&entry.id===value.userMessageId)||(entry.role==='assistant'&&entry.id===value.assistantMessageId)))return;
 return value as NativeAgentTurnMetadata;
}
/** A stale web whole-history save cannot overwrite or omit native server-owned bubbles. */
export function preserveNativeAgentHistory(prior:ReadonlyArray<NativeAgentHistoryEntry>,incoming:ReadonlyArray<NativeAgentHistoryEntry>):NativeAgentHistoryEntry[]{
 const owned=new Map(prior.filter(entry=>nativeAgentTurnMetadata(entry)).map(entry=>[entry.id!,entry]));
 const seen=new Set<string>();
 const merged:NativeAgentHistoryEntry[]=[];
 for(const entry of incoming){
  if(!entry||typeof entry!=='object'||Array.isArray(entry))continue;
  const canonical=entry?.id?owned.get(entry.id):undefined;
  if(canonical){if(!seen.has(entry.id!)){seen.add(entry.id!);merged.push(canonical);}continue;}
  if(entry&&Object.hasOwn(entry,'serverNativeAgent')){const {serverNativeAgent,...rest}=entry;merged.push(rest);continue;}
  merged.push(entry);
 }
 for(const [id,entry] of Array.from(owned.entries()))if(!seen.has(id))merged.push(entry);
 return orderChatDeliveries(merged);
}
